module.exports = __webpack_public_path__ + "83dc6c06797af031058c856c2f71b449.png";